import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule, LinkModule } from '@com-delta-idp/mnx-ui-kit';
import { PartnersComponent } from './partners.component';

@NgModule({
  declarations: [PartnersComponent],
  imports: [CommonModule, ImageModule, LinkModule],
  exports: [PartnersComponent]
})
export class PartnersModule {}
